// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"235":"088df877","493":"1469b9a0","655":"069e3805","667":"17e540fd","928":"c326b646"}[chunkId] + ".css";
};